export default __webpack_public_path__ + "static/media/is_dead.9909fd9e.png";